import { useEffect, useRef, useState } from 'react';
import useSelectedAssignmentsCount from '../../../helpers/hooks/use-selected-assignments-count/use-selected-assignments-count';

const useAssignmentsActionBar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const selectedAssignmentsCount = useSelectedAssignmentsCount();
  const prevSelectedAssignmentsCount = useRef(0);

  useEffect(() => {
    const firstAssignmentSelected =
      prevSelectedAssignmentsCount.current === 0 &&
      selectedAssignmentsCount > 0;
    const lastAssignmentDeselected =
      prevSelectedAssignmentsCount.current > 0 &&
      selectedAssignmentsCount === 0;

    if (firstAssignmentSelected) {
      setIsCollapsed(false);
    } else if (lastAssignmentDeselected) {
      setIsCollapsed(true);
    }

    prevSelectedAssignmentsCount.current = selectedAssignmentsCount;
  }, [selectedAssignmentsCount]);

  const toggleIsCollapsed = () => {
    setIsCollapsed(!isCollapsed);
  };

  return { isCollapsed, toggleIsCollapsed };
};

export default useAssignmentsActionBar;



// WEBPACK FOOTER //
// ./components/assignments-action-bar/hooks/use-assignments-action-bar.js